// extracted by mini-css-extract-plugin
module.exports = {"RequestResetPage":"RequestResetPage_RequestResetPage__3ozBs"};